const list = [
  // 权限管理
  { name: "权限管理", menuItem: { name: "权限管理", route: "/role-manage", iconClass: "el-icon-lock" } },
  { name: "管理员管理", menuItem: { name: "管理员管理", route: "/admin-list" } },
  { name: "角色管理", menuItem: { name: "角色管理", route: "/role-list" } },
  { name: "菜单管理", menuItem: { name: "菜单管理", route: "/menu-list" } },

  // 内容管理
  { name: "内容管理", menuItem: { name: "内容管理", route: "/content-manage", iconClass: "el-icon-suitcase" } },
  // { name: "轮播图管理", menuItem: { name: "轮播图管理", route: "/carousel-list" } },
  { name: "关于我们管理", menuItem: { name: "关于我们", route: "/about-us" } },
  // { name: "行业方案管理", menuItem: { name: "行业洞察", route: "/industry-case" } },
  { name: "友情链接管理", menuItem: { name: "友情链接管理", route: "/friendly-link" } },

  // 表单管理
  { name: "表单管理", menuItem: { name: "表单管理", route: "/form-manage", iconClass: "el-icon-folder" } },
  { name: "预约演示列表", menuItem: { name: "预约演示列表", route: "/demo-list" } },
  { name: "商务合作列表", menuItem: { name: "商务合作列表", route: "/cooperation-list" } },
  { name: "高端定制", menuItem: { name: "高端定制", route: "/customization-list" } },
  // { name: "白皮书下载", menuItem: { name: "白皮书下载", route: "/whitePaper-list" } },
  // SEO设置
  { name: "SEO设置", menuItem: { name: "SEO设置", route: "/seo-manage", iconClass: "el-icon-tickets" } },
  { name: "基础设置", menuItem: { name: "基础设置", route: "/basic-set" } },
  // { name: "网站地图管理", menuItem: { name: "网站地图管理", route: "/web-map" } },

  // 案例管理
  { name: "案例管理", menuItem: { name: "案例管理", route: "/case-manage", iconClass: "el-icon-suitcase" } },
  { name: "案例分类", menuItem: { name: "案例分类", route: "/case-classify" } },
  { name: "案例列表", menuItem: { name: "案例列表", route: "/case-list" } },
  // 热区管理
  { name: "热区管理", menuItem: { name: "热区管理", route: "/zone-manage", iconClass: "el-icon-suitcase" } },
  { name: "热区列表", menuItem: { name: "热区列表", route: "/zone-list" } },

  // 行业解决方案管理
  {
    name: "行业解决方案管理",
    menuItem: { name: "行业解决方案管理", route: "/solution-manage", iconClass: "el-icon-suitcase" },
  },
  { name: "行业解决方案列表", menuItem: { name: "行业解决方案列表", route: "/solution-list" } },

  // 企微学院管理
  { name: "文章资讯", menuItem: { name: "文章资讯", route: "/college-manage", iconClass: "el-icon-suitcase" } },
  { name: "标签管理", menuItem: { name: "标签管理", route: "/tag-list", iconClass: "el-icon-suitcase" } },
  { name: "分类管理", menuItem: { name: "分类管理", route: "/classify-list", iconClass: "el-icon-suitcase" } },
  { name: "文章列表", menuItem: { name: "文章列表", route: "/article-list", iconClass: "el-icon-suitcase" } },
];
const mapper = new Map();
list.forEach((value) => {
  mapper.set(value.name, value.menuItem);
});

export default mapper;
